export default {
  TD: 'TD',
  GL: 'GL',
};
